import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const Layout = () => {
  const { pathname } = useLocation();
  const isContactPortal = pathname === "/contact" || pathname === "/fan-mail" || pathname === "/check-status";
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    document.title = "Cresway Media";
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute("content", pathname === "/" ? "index, follow" : "noindex, follow");
  }, [pathname]);

  return (
    <div className={`min-h-screen flex flex-col ${isContactPortal ? "bg-[#08090A] text-white" : "bg-[#FBF9F5] text-[#0A0A0A]"}`}>
      {!isContactPortal && <Header />}
      <main className={`flex-1 ${isContactPortal ? "" : "pt-20"}`}>
        <Outlet />
      </main>
      {!isContactPortal && <Footer />}
    </div>
  );
};
